const Utilities = {
    addMobileStyle: (id, styleString) => {
        const mobileStyleId = 'mobileStyle';
        let element = document.getElementById(mobileStyleId);
        let html;
        if (element) {
            html = element.innerHTML;
        }
        html = `${html || ''}${Utilities.createMobileStyle(id, styleString)}`;
        if (!element) {
            element = document.createElement('STYLE');
            element.id = mobileStyleId;
            document.head.appendChild(element);
        }
        element.innerHTML = html;
    },

    copyObject: (source, destination) => {
        if (!source || !destination) {
            return;
        }
        for (let id in source) {
            destination[id] = source[id];
        }
    },

    createMobileStyle: (id, styleString) => `@media(max-width: 768px){.tennies #${id}{${styleString}}}`,

    extractStyle: (value) => {
        let testString = '<span style="';
        let index = value.indexOf(testString);
        if (index < 0) {
            testString = '<span class="custom-color" style="';
            index = value.indexOf(testString);
        }
        if (index < 0) {
            return;
        }
        value = value.substring(index + testString.length);
        testString = '"';
        index = value.indexOf(testString);
        if (index < 0) {
            return;
        }
        return value.substring(0, index);
    },

    generateUniqueId: () => {
        return (Math.random() * (new Date().getTime())).toString().replace('.', '_');
    },

    getInnerText: (html) => {
        const temp = document.createElement('DIV');
        temp.innerHTML = html || '';
        return temp.innerText;
    },

    _injectStyleIntoString: (styleString, injectString, options) => {
        let testString = '<span style="';
        let index = styleString.indexOf(testString);
        if (index < 0) {
            testString = '<span class="custom-color" style="';
            index = styleString.indexOf(testString);
        }
        if (index >= 0) {
            index += testString.length;
            let insertionString = injectString;
            if (options && options.prepend == true) {
                if (insertionString.charAt(insertionString.length - 1) != ';') {
                    insertionString += ';'
                }
                return styleString.substring(0, index) + insertionString + styleString.substring(index);
            }
            const endIndex = styleString.indexOf('"', index);
            if (endIndex >= 0) {
                if (options && options.replace == true) {
                    return styleString.substring(0, index) + insertionString + styleString.substring(endIndex);
                }
                switch (styleString.charAt(endIndex - 1)) {
                    case ';':
                    case '"':
                        break;
                    default:
                        insertionString = `;${insertionString}`;
                        break;
                }
                return styleString.substring(0, endIndex) + insertionString + styleString.substring(endIndex);
            }
        } else {
            testString = '<span';
            index = styleString.indexOf(testString);
            if (index >= 0) {
                index += testString.length;
                return styleString.substring(0, index) + ` style="${injectString}"` + styleString.substring(index);
            }
        }
        return styleString;
    },

    injectStyleIntoString: (styleString, injectString, options) => {
        const components = styleString.split('<span');
        let updatedString = '';
        let skipped = [];
        for (let component of components) {
            if (!component) {
                continue;
            }
            if (component.indexOf('<p') >= 0) {
                skipped.push(component);
            } else {
                updatedString += skipped.join('');
                skipped = [];
                updatedString += Utilities._injectStyleIntoString(`<span${component}`, injectString, options);
            }
        }
        return updatedString;
    },

    isHTMLContentEmpty: (html) => Utilities.getInnerText(html).trim().length == 0,

    isValidURL: (document, string) => {
        if (!document || !string) {
            return false;
        }
        var a = document.createElement('a');
        a.href = string;
        return (a.host && a.host != window.location.host);
    },

    moveTokenStyle: (tokenString, style) => {
        let endIndex;
        let testString = 'style="';
        let index = tokenString.indexOf(testString);
        while (index >= 0) {
            index += testString.length;
            endIndex = tokenString.indexOf('"', index);
            if (index < 0) {
                break;
            }
            Utilities.copyObject(Utilities.styleFromString(tokenString.substring(index, endIndex)), style);
            index = tokenString.indexOf(testString, endIndex);
        }

        let typeStyle = 'p';
        testString = 'data-heading="';
        index = tokenString.indexOf(testString);
        if (index >= 0) {
            index += testString.length;
            endIndex = tokenString.indexOf('"', index);
            if (endIndex > 0) {
                typeStyle = tokenString.substring(index, endIndex);
            }
        }
        return typeStyle;
    },

    parseQueryString: (query) => {
        const pairs = query.split('&');
        const queryStringMap = {};
        for (var i = 0; i < pairs.length; i++) {
            const pair = pairs[i].split('=');
            // If first entry with this name
            if (typeof queryStringMap[pair[0]] === 'undefined') {
                queryStringMap[pair[0]] = decodeURIComponent(pair[1]);
                // If second entry with this name
            } else if (typeof queryStringMap[pair[0]] === 'string') {
                const arr = [queryStringMap[pair[0]], decodeURIComponent(pair[1])];
                queryStringMap[pair[0]] = arr;
                // If third or later entry with this name
            } else {
                queryStringMap[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }
        return queryStringMap;
    },

    rgbaToHex: (rgba) => {
        if (!rgba) {
            return {};
        }
        let _rgba = rgba.replace('rgba(', '');
        let r, redValue, g, greenValue, b, blueValue, a;
        let index = _rgba.indexOf(',');
        if (index >= 0) {
            redValue = parseInt(_rgba.substring(0, index), 10);
            if (isNaN(redValue)) {
                r = '00';
            } else {
                r = redValue.toString(16);
                if (r.length == 1) {
                    r = '0' + r;
                }
            }
            _rgba = _rgba.substring(index + 1);
        } else {
            return { hex: rgba };
        }
        index = _rgba.indexOf(',');
        if (index >= 0) {
            greenValue = parseInt(_rgba.substring(0, index), 10);
            if (isNaN(greenValue)) {
                g = '00';
            } else {
                g = greenValue.toString(16);
                if (g.length == 1) {
                    g = '0' + g;
                }
            }
            _rgba = _rgba.substring(index + 1);
        }
        index = _rgba.indexOf(',');
        if (index >= 0) {
            blueValue = parseInt(_rgba.substring(0, index), 10);
            if (isNaN(blueValue)) {
                b = '00';
            } else {
                b = blueValue.toString(16);
                if (b.length == 1) {
                    b = '0' + b;
                }
            }
            _rgba = _rgba.substring(index + 1);
        }
        index = _rgba.indexOf(')');
        if (index >= 0) {
            a = parseFloat(_rgba.substring(0, index));
        }
        if (isNaN(a)) {
            a = 1;
        }
        return { hex: `${r}${g}${b}`, alpha: a, r: redValue, g: greenValue, b: blueValue };
    },

    styleFromString: (styleString) => {
        const style = {};
        if (styleString) {
            styleString.split(';').forEach((d) => {
                const pair = d.split(':');
                if (pair.length < 2 || pair[1] == undefined) {
                    return;
                }
                const value = pair[1].toString().trim();
                if (!value) {
                    return;
                }
                let key = pair[0].toString().trim();
                let index = key.indexOf('-');
                if (index > 0) {
                    key = key.substring(0, index) + key.substring(index + 1, index + 2).toUpperCase() + key.substring(index + 2);
                }
                style[key] = value;
            })
        }
        return style;
    },

    typeStyleFromString: (value) => {
        let testString = 'class="'
        let index = value.indexOf(testString);
        if (index < 0) {
            return;
        }
        index += testString.length;
        let end = value.indexOf('"', index)
        if (end < 0) {
            return;
        }
        return value.substring(index, end);
    },

    uuidv4: () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
}

export default Utilities;